/**
 * 配置具体表单字段 前端工程和val-loader使用
 */

module.exports = {
  BDOMerchantForm: [
    'firstName',
    'middleName',
    'lastName',
    'suffix',
    '---',
    'mobile',
    'email',
    '---', // 分割线
    'mchPassword',
    'confirmPassword'
  ],
  BDOMerchantFormLite: [
    'firstName',
    'middleName',
    'lastName',
    'suffix',
    '---', // 分割线
    'mobile',
    'email',
  ],
  ExistingBDOPartner: [
    'busiStoreName',
    '',
    'busiStoreContact',
    '',
    'busiStoreMobileNumber',
    'busiStoreEmailAddress',
    'optionEmailAddress',
    'optionMobileNumber',
    'optionLandline',
  ],
  ExistingBDOMerchant: [
    'busiStoreName',
    '',
    '',
    'merchantIdEm',
    'busiStoreContact',
    'busiStoreMobileNumber',
    'busiStoreEmailAddress',
    'optionEmailAddress',
    'optionMobileNumber',
    'optionLandline'
  ],
  SolePropD: [
    'streetAddress',
    'subdivision',
    'province',
    'city',
    'barangay',
    'zipCode',
  ],
  SolePropE: [
    'birthday',
    'countryOfBirth',
    'cityOfBirth',
    'citizenship',
    '---', // 分割线
    'tin',
  ],
  SolePropF: [
    'businessName',
    'businessDescription',
  ],
  SolePropG: [
    'streetAddress',
    'subdivision',
    'province',
    'city',
    'barangay',
    'zipCode',
  ],
  SolePropI: [
    'bankAccountType',
    "accountName",
    "accountNumber",
  ],
  IndividualD:[
    'streetAddress',
    'subdivision',
    'province',
    'city',
    'barangay',
    'zipCode',
  ],
  IndividualE:[
    'month',
    'day',
    'year',
    'tin',
    'countryOfBirth',
    '',
    'cityOfBirth',
    '',
    'citizenship',
  ],
  IndividualF:[
    'businessName_1',
    'businessDescription',
  ],
  IndividualG:[
    'streetAddress',
    'subdivision',
    'province',
    'city',
    'barangay',
    'zipCode',
  ],
  IndividualI:[
    'bankAccountType',
    "accountName",
    "accountNumber",
  ],
  NewMerchantIndividualA:[
    'customFirstName',
    'customMiddleName',
    'customLastName',
    'customSuffix',
    'customMobileNum',
    'customEmail',
    'customOptEmail',
    'customOptMobile',
    'customOptLandline',
  ],
  NewMerchantIndividualB:[
    'homeAddr1',
    'homeAddr2',
    'homeCountry',
    'homeProState',
    'cityAndZipCode',
  ],
  NewMerchantIndividualC:[
    'birthDate',
    'birthCountry',
    'birthCity',
    'citizenship',
    'acrNumber',
    'civilStatus',
    'motherFullMaiName',
    'sssOrGsisNo',
    'sourceOfFunds'
  ],
  NewMerchantIndividualD:[
    'idType',
    'idNumber'
  ],
  NewMerchantIndividualH:[
    "busiStoreName",
    "busiStoreContact" ,
    "busiNature",
    "busiDescript",
    "tinNumber",
    "tinStatus",
    "yearsNumber",
    "acquirerStatus"
  ],
  NewMerchantIndividualI:[
    "busiStoreLandline",
    "busiStoreMobileNum",
    "busiStoreEmailAddress",
    "alternateEmailAddress",
    "websiteUrl",
    "facebook",
    "instagram",
    "shopee",
    "socialMedia"
  ],
  NewMerchantIndividualJ:[
    "busiStoreAddr1",
    "busiStoreAddr2",
    "busiStoreCountry",
    "busiStoreProState",
    "cityAndZipCode"
  ],

  NewBDOPartnerSolePropA: [
    'customFirstName',
    'customMiddleName',
    'customLastName',
    'customSuffix',
    'customMobileNum',
    'customEmail',
    'customOptEmail',
    'customOptMobile',
    'customOptLandline',
  ],
  NewMerchantSolePropA:[
    'customFirstName',
    'customMiddleName',
    'customLastName',
    'customSuffix',
    'customMobileNum',
    'customEmail',
    'customOptEmail',
    'customOptMobile',
    'customOptLandline',
  ],
  NewBDOPartnerSolePropJ: [
    'busiStoreName',
    'busiStoreContact',
    'busiNature',
    'busiDescript',
  ],
  NewBDOPartnerSolePropK: [
    'busiStoreLandline',
    'busiStoreMobile',
    'busiStoreEmailAddress',
  ],
  NewBDOPartnerSolePropL: [
    'busiStoreAddr1',
    'busiStoreAddr2',
    'busiStoreCountry',
    'busiStoreProState',
    'cityAndZipCode',
  ],
  NewBDOPartnerSolePropO: [
    'branchName',
    'terminalNum',
    'branchContact',
    'branchLandline',
    'branchMobileNum',
    'branchEmailAddr',
    'branchAddr1',
    'branchAddr2',
    'branchCountry',
    'branchProState',
    'cityAndZipCode',
  ],
  NewBDOPartnerSolePropQ: [
    'settleAccountType',
    'settleAccountNum'
  ],
  NewBDOPartnerCorp:[
    "busiStoreName",
    "busiStoreContact",
    "busiStoreMobileNumber",
    "busiStoreEmailAddress",
    "optionEmailAddress",
    "optionMobileNumber",
    "optionLandline",
  ],
  NewMerchantSolePropB:[
    'homeAddr1',
    'homeAddr2',
    'homeCountry',
    'homeProState',
    'cityAndZipCode',
  ],
  NewMerchantSolePropC:[
    'birthDate',
    'birthCountry',
    'birthCity',
    'citizenship',
    'acrNumber',
    'civilStatus',
    'motherFullMaiName',
    'sssOrGsisNo'
  ],
  NewMerchantSolePropD:[
    'idType',
    'idNumber'
  ],
  NewMerchantSolePropH:[
    "busiStoreName",
    "busiStoreContact" ,
    "busiNature",
    "busiDescript",
    "tinNumber",
    "tinStatus",
    "yearsNumber",
    "acquirerStatus"
  ],
  NewMerchantSolePropI:[
    "busiStoreLandline",
    "busiStoreMobileNum",
    "busiStoreEmailAddress",
    "alternateEmailAddress",
    "websiteUrl",
    "facebook",
    "instagram",
    "shopee",
    "socialMedia"
  ],
  NewMerchantSolePropJ:[
    "busiStoreAddr1",
    "busiStoreAddr2",
    "busiStoreCountry",
    "busiStoreProState",
    "cityAndZipCode"
  ],
  NewMerchantCorpA:[
    "busiStoreName",
    "busiStoreContact",
    "busiStoreMobileNumber",
    "busiStoreEmailAddress",
    "optionEmailAddress",
    "optionMobileNumber",
    "optionLandline",
  ],
  NewMerchantCorpD:[
    'businessName',
    'tin',
    'businessDescription',
  ],
  NewMerchantCorpE:[
    'streetAddress',
    'subdivision',
    'province',
    'city',
    'barangay',
    'zipCode',
  ],
  NewMerchantCorpF:[
    'least20',
  ],
  NewMerchantCorpG:[
    'businessauthorized',
  ],
  NewMerchantCorpH:[
    'bankAccountType',
    "accountName",
    "accountNumber",
  ],
  PartnershipD:[
    'businessName',
    'tin',
    'businessDescription',
  ],
  PartnershipE:[
    'streetAddress',
    'subdivision',
    'province',
    'city',
    'barangay',
    'zipCode',
  ],
  PartnershipF:[
    'least20',
  ],
  PartnershipG:[
    'businessauthorized',
  ],
  PartnershipH:[
    'bankAccountType',
    "accountName",
    "accountNumber",
  ],
  BdoMerchantA:[
    'merchantId',
    'businessName_1',
    'city_1',
    'purposeOfApplication'
  ]
};
